import { render, staticRenderFns } from "./ManageOfflineFarmers.vue?vue&type=template&id=2edadecc&scoped=true"
import script from "./ManageOfflineFarmers.vue?vue&type=script&lang=js"
export * from "./ManageOfflineFarmers.vue?vue&type=script&lang=js"
import style0 from "./ManageOfflineFarmers.vue?vue&type=style&index=0&id=2edadecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edadecc",
  null
  
)

export default component.exports